module.exports = __webpack_public_path__ + "fonts/lato-black-greek.b10bf55.woff";